import React, { useState, useEffect } from "react";
import {
  Autocomplete,
  Box,
  IconButton,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from "moment-timezone";
import CheckOutlined from "@mui/icons-material/CheckOutlined";
import ClearOutlined from "@mui/icons-material/ClearOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";

const ENTER_KEY_CODE = 13;
const DEFAULT_LABEL_PLACEHOLDER = "Click To Edit";

const EditableFieldDate = ({
  fieldType,
  field,
  initialValue,
  tip,
  displayValue,
  lookupCollection,
  lookupIdField,
  lookupLabel,

  onChange = () => {},
  ...props
}) => {

  const [buttonClicked, setButtonClicked] = useState(false);
  const [isEditing, setEditing] = useState(false);

  const [value, setValue] = useState(() => {
    const myMoment = moment(initialValue);
    //const myMoment = moment.tz(initialValue, "UTC");
    if (myMoment.isValid()) {
      return myMoment;
    } else {
      return moment.unix(moment.now() / 1000);
    }
  });

  useEffect(() => {
    setValue(() => {

      const myMoment = moment(initialValue);
      //const myMoment = moment.tz(initialValue, "UTC")
      if (myMoment.isValid()) {
        return myMoment;
      } else {
        return moment.unix(moment.now() / 1000);
      }
    });
  }, [initialValue]);


  const handelEditMode = () => {
    setEditing(true);
  };

  const handelDisplayMode = () => {
    setEditing(false);
  };

  const handelSave = (e) => {
    
   

    const utcTime = value.utc();
    const formatedTime =utcTime.format("YYYY-MM-DDTHH:mm:ss[Z]")
    onChange(formatedTime);
    handelDisplayMode();
  };

  const handelReset = (e) => {
    setValue(() => {

      const myMoment = moment(initialValue);
      if (myMoment.isValid()) {
        return myMoment;
      } else {
        return moment.unix(moment.now() / 1000);
      }
    });
    handelDisplayMode();
  };

  if (isEditing) {
    if (lookupCollection != undefined && lookupCollection != "") {
      return (
        <Autocomplete
          width="100%"
          size="small"
          id={`autocomplete-${field}`}
          //options={options}
          //getOptionLabel={(option) => option.label}

          includeInputInList
          renderInput={(params) => (
            <TextField
              inputProps={{
                value,
              }}
              {...params}
              fullWidth
              variant="outlined"
              //value={network.find(option => option.value === values.role)?.label || ''}
            />
          )}
        />
      );
    } else {
      return (
        <Box
          display={"flex"}
          flexDirection={"row"}
          gap=".4rem"
          border={0}
          p={".2rem"}
        >
          <DateTimePicker
            value={value}
            onChange={(newValue) => setValue(newValue)}
            views={['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
            //autoFocus
            slotProps={{
              textField: {
                size: "small",
                variant: "standard",
              },
            }}

            sx={{ flex: 1 }} 

          />
          <Stack gap=".2rem" direction="row">
            <IconButton
              size="small"
              aria-label="Save"
              onClick={handelSave}
              onMouseDown={() => setButtonClicked(true)}
              onMouseUp={() => setButtonClicked(false)}
            >
              <CheckOutlined fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              aria-label="Cancel"
              onClick={handelReset}
              onMouseDown={() => setButtonClicked(true)}
              onMouseUp={() => setButtonClicked(false)}
            >
              <ClearOutlined fontSize="small" />
            </IconButton>
          </Stack>
        </Box>
      );
    }
  }

  return (
    <Tooltip title={tip} placement="bottom-start">
      <Stack gap=".2rem" direction="row" alignItems={"flex-start"}
        p={"2px"}
        onClick={handelEditMode}
        // sx={{
        //   borderRadius: 1,
        //   cursor: "pointer",
        //   border: "1px solid transparent", // Initially transparent border
        //   "&:hover": {
        //     border: "1px solid #000", // Change border color on hover
        //   },
        // }}

        sx={{
          cursor: "pointer",
        }}


      >
        {displayValue}

        <IconButton
              size="small"
              aria-label="Edit"
              onClick={handelReset}
              onMouseDown={() => setButtonClicked(true)}
              onMouseUp={() => setButtonClicked(false)}
            >
              <EditOutlined fontSize="small" />
            </IconButton>

      </Stack>
    </Tooltip>
  );
};

export default EditableFieldDate;
